import styled from 'styled-components';

export const StyledHeader = styled.h3`
    line-height: 1.2em;
`;
